export const hasLower = (input) => /[a-z]/.test(input);

export const hasCapital = (input) => /[A-Z]/.test(input);

export const hasNumber = (input) => /\d/.test(input);
